<template>
  <div class="statistics-table__partner">
    <picture v-if="resume.avatar"
             class="statistics-table__partner-img">
      <img :src="resume.avatar"
           alt="User"/>
    </picture>
    <div v-else
         :style="{backgroundColor: getColor()}"
         class="statistics-table__partner-img  _placeholder">
      {{ getAbbr(resume.lastname, resume.firstname) }}
    </div>
    <div class="statistics-table__partner-name">
      {{ resume.fullname }}
    </div>
  </div>
</template>

<script>
  const colors = ['#9c9bb6', '#d38282', '#e4bf68']
  let colorIndex = 0

  export default {
    name: 'StatisticsPageTablePartner',
    props: {
      resume: Object
    },
    data() {
      return {}
    },
    methods: {
      getColor() {
        if (colors.length === colorIndex) {
          colorIndex = 0
        }

        const color = colors[colorIndex]
        colorIndex++

        return color
      },
      getAbbr(first, second) {
        return (first && first[0] || '-') + (second && second[0] || '-')
      }
    }
  }
</script>

<style lang="less">

</style>
